import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero.jsx";
import InsuranceGuided from "../components/InsuranceGuided.jsx";
import FinancialCalculators from "../components/FinancialCalculators.jsx";
import PolicyBenefits from "../components/PolicyBenefits.jsx";
import WhyChoosePolicySamjho from "../components/WhyChoosePolicySamjho.jsx";
import TrustSection from "../components/TrustSection.jsx";
import FaqSection from "../components/FaqSection.jsx";
import InsuranceSupport from "../components/InsuranceSupport.jsx";
import Blog from "../components/Blog.jsx";
import PolicyiesSlider from "../components/PolicyiesSlider.jsx";
import { UserContext } from "../UserContext";

const Home = () => {
  const location = useLocation();
  const { logout } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const scrollToSection = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      };
      requestAnimationFrame(() => {
        scrollToSection();
        setTimeout(() => {
          scrollToSection();
          window.history.replaceState(null, "", window.location.pathname + window.location.search);
        }, 100);
      });
    }
  }, [location]);

  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.split("?")[1];
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const isLogout = params.get("logout");
      if (isLogout === "true") {
        logout();
        navigate("/home");
      }
    }
  }, [logout, navigate]);

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Policy Samjho",
    "url": "https://policysamjho.com/",
    "logo": "https://policysamjho.com/policySamjhoFaviconLogo.png",
    "description": "Policy Samjho provides expert insurance guidance and consultation services in India. We help users understand, compare, and select the best insurance policies with personalized advice.",
    "founder": {
      "@type": "Person",
      "name": "Arvind Sharma"
    },
    "contactPoint": [{
      "@type": "ContactPoint",
      "telephone": "+91-9584484800",
      "email": "info@policysamjho.com",
      "contactType": "customer service",
      "areaServed": "IN"
    }],
    "sameAs": [
      "https://www.facebook.com/policysamjho",
      "https://twitter.com/policysamjho",
      "https://www.instagram.com/policysamjho/",
      "https://www.linkedin.com/company/policysamjho"
    ]
  };

  return (
    <div>
      <Helmet>
        <title>Insurance Guidance India | Expert Policy Advice | Policy Samjho</title>
        <meta
          name="description"
          content="Get expert insurance guidance to make informed policy choices. Policy Samjho offers personalized advice and simple explanations to help you choose the best insurance plans in India."
        />
        
        <meta
          name="keywords"
          content="insurance guidance, policy consultation, insurance expert advice, clarity in insurance, compare insurance policies, best insurance policies India, insurance policy review, policy upload, personalized insurance recommendations India, insurance advice India, insurance policy help, insurance policy consultation India"
        />
        
        <link rel="canonical" href="https://policysamjho.com/" />
        <meta property="og:title" content="Insurance Guidance India | Expert Policy Advice | Policy Samjho" />
        <meta property="og:description" content="Get expert insurance guidance to make informed policy choices. Personalized advice and simple explanations for all your insurance needs." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://policysamjho.com/" />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
        />
      </Helmet>

      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WSBD7JKL"
          height="0" width="0" style={{ display: "none", visibility: "hidden" }}></iframe>
      </noscript>

      <Hero logoAlt="Policy Samjho - Trusted Insurance Guidance in India" />
      <InsuranceGuided />
      <div id="financial-calculators-section">
        <FinancialCalculators />
      </div>
      <PolicyBenefits />
      <WhyChoosePolicySamjho />
      <TrustSection />
      <FaqSection />
      <InsuranceSupport />
      <Blog />
      <PolicyiesSlider category="" />
    </div>
  );
};

export default Home;